import * as actions from './actions';
import { state } from './models';
import { getters } from './getters';
import { mutations } from './mutations';

export const powerBiReportingModule = {
  state,
  actions,
  getters,
  mutations
};
